import * as React from 'react';

interface CertificateDetails {
  customerName: string;
  trainingName: string;
  completionDate: string;
  certificateId: string;
  instructorName: string;
  customerEmail: string;
  hoursCompleted: string;
  certificateUrl: string;
  certificateValidUntil: string;
}

interface CertificateParticipationEmailProps {
  customerName?: string;
  trainingName?: string;
  completionDate?: string;
  certificateId?: string;
  instructorName?: string;
  customerEmail?: string;
  hoursCompleted?: string;
  certificateUrl?: string;
  certificateValidUntil?: string;
}

export const CertificateParticipationEmail: React.FC<CertificateParticipationEmailProps> = ({
  customerName = "João Silva",
  trainingName = "Análise Avançada de Dados",
  completionDate = "20 Abr, 2025",
  certificateId = "CERT-3842",
  instructorName = "Dra. Ana Martins",
  customerEmail = "joao.silva@email.com",
  hoursCompleted = "8 horas",
  certificateUrl = "https://trivium.com.br/certificates/CERT-3842",
  certificateValidUntil = "20 Abr, 2026",
}) => {
  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <img 
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Logo%20Trivium%20Rebranded%20Branco%20150%20dpi-0VfiiO2tOZNdZlvY5A7z3saYZGysgq.png" 
          alt="Trivium"
          style={logoImageStyle}
        />
      </div>
      
      {/* Content */}
      <div style={contentStyle}>
        <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ backgroundColor: '#E7F2FF' }}>
          <tr>
            <td align="center" style={{ padding: '40px 20px' }}>
              <table cellPadding="0" cellSpacing="0" border={0} width="100%" style={{ maxWidth: '400px' }}>
                {/* Círculo com emoji */}
                <tr>
                  <td align="center" style={{ paddingBottom: '30px' }}>
                    <div style={{ 
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '50%', 
                      backgroundColor: '#1F1746', 
                      display: 'inline-block',
                      textAlign: 'center',
                      lineHeight: '60px'
                    }}>
                      <span style={{ fontSize: '30px' }}>🎓</span>
                    </div>
                  </td>
                </tr>
                
                {/* Título */}
                <tr>
                  <td align="center" style={{ paddingBottom: '15px' }}>
                    <h1 style={{ 
                      margin: '0',
                      fontSize: '28px',
                      color: '#333333',
                      fontWeight: '600'
                    }}>
                      Certificado Emitido!
                    </h1>
                  </td>
                </tr>
                
                {/* Mensagem */}
                <tr>
                  <td align="center" style={{ paddingBottom: '25px' }}>
                    <p style={{ 
                      margin: '0',
                      fontSize: '16px',
                      color: '#666666'
                    }}>
                      Parabéns pela conclusão da sua formação.
                    </p>
                  </td>
                </tr>
                
                {/* Badge do ID do certificado */}
                <tr>
                  <td align="center">
                    <div style={{ 
                      backgroundColor: '#FFD600',
                      borderRadius: '24px',
                      color: '#333333',
                      fontWeight: '600',
                      fontSize: '15px',
                      padding: '12px 25px',
                      display: 'inline-block'
                    }}>
                      Certificado #{certificateId}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        
        <div style={contentContainerStyle}>
          <h2 style={titleStyle}>Olá, {customerName}!</h2>
        </div>

        {/* Certificate Preview */}
        <div style={certificatePreviewContainerStyle}>
          <img 
            src="https://via.placeholder.com/500x300/E5F0FF/1F305F?text=Certificado+de+Participação" 
            alt="Certificado Preview"
            style={certificatePreviewStyle}
          />
        </div>
        
        <div style={courseCardStyle}>
          <div style={courseHeaderStyle}>
            <h3 style={courseTitleStyle}>{trainingName}</h3>
          </div>
          
          <div style={courseDetailsStyle}>
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Data de Conclusão:</div>
                <div style={detailValueStyle}>{completionDate}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Carga Horária:</div>
                <div style={detailValueStyle}>{hoursCompleted}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Instrutor:</div>
                <div style={detailValueStyle}>{instructorName}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#666666"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Válido até:</div>
                <div style={detailValueStyle}>{certificateValidUntil}</div>
              </div>
            </div>
            
            <div style={detailBlockStyle}>
              <div style={detailIconContainerStyle}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#4CAF50"/>
                </svg>
              </div>
              <div>
                <div style={detailLabelStyle}>Status:</div>
                <div style={{ ...detailValueStyle, color: '#4CAF50', fontWeight: '600' }}>
                  Certificado Emitido
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div style={nextStepsStyle}>
          <h3 style={nextStepsTitleStyle}>Informações Importantes</h3>
          <ul style={infoListStyle}>
            <li style={infoListItemStyle}>Seu certificado estará disponível para download por 1 ano</li>
            <li style={infoListItemStyle}>O certificado pode ser verificado online através do link abaixo</li>
            <li style={infoListItemStyle}>Para problemas com o certificado, entre em contato com nossa equipe de suporte</li>
          </ul>
          <div style={buttonContainerStyle}>
            <a href={certificateUrl} style={buttonStyle}>
              Baixar Certificado
            </a>
            <a href={`${certificateUrl}/verify`} style={secondaryButtonStyle}>
              Verificar Autenticidade
            </a>
          </div>
        </div>
        
        <hr style={hrStyle} />
        
        <div style={footerContentStyle}>
          <p style={footerStyle}>
            Se você tiver alguma dúvida, entre em contato conosco:
          </p>
          <div style={contactChannelsStyle}>
            <p style={contactChannelStyle}>✉️ suporte@trivium.com.br&nbsp;&nbsp;📱 (11) 3181-5940</p>
          </div>
          <p style={footerStyle}>
            Atenciosamente,<br />
            Equipe Trivium
          </p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={emailFooterStyle}>
        <p style={copyrightStyle}>
          © 2025 Trivium. Todos os direitos reservados.
        </p>
        <div style={footerLinksStyle}>
          <a href="#" style={footerLinkStyle}>Termos de Uso</a>
          <span style={footerDividerStyle}>|</span>
          <a href="#" style={footerLinkStyle}>Política de Privacidade</a>
        </div>
      </div>
    </div>
  );
};

// Estilos
const brandColor = '#1F1746';
const accentColor = '#3E5FBA';
const backgroundColor = '#F5F7FA';
const textColor = '#333333';
const secondaryTextColor = '#666666';

const containerStyle = {
  fontFamily: "'Satoshi', Arial, sans-serif",
  maxWidth: '600px',
  margin: '0 auto',
  backgroundColor: backgroundColor,
};

const headerStyle = {
  backgroundColor: brandColor,
  padding: '25px',
  textAlign: 'center' as const,
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

const logoImageStyle = {
  maxWidth: '180px',
  height: 'auto',
  display: 'block',
  margin: '0 auto',
};

const contentStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '0 0 8px 8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
  padding: '0',
  margin: '0 0 20px 0',
  overflow: 'hidden',
};

const contentContainerStyle = {
  padding: '0 40px',
};

const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: brandColor,
  marginBottom: '16px',
  padding: '24px 0 0 0',
};

const certificatePreviewContainerStyle = {
  textAlign: 'center' as const,
  margin: '0 40px 24px',
};

const certificatePreviewStyle = {
  maxWidth: '100%',
  height: 'auto',
  borderRadius: '8px',
  border: '1px solid #E1E4E8',
};

const courseCardStyle = {
  border: '1px solid #E1E4E8',
  borderRadius: '8px',
  overflow: 'hidden',
  margin: '24px 40px',
};

const courseHeaderStyle = {
  backgroundColor: brandColor,
  padding: '16px 24px',
};

const courseTitleStyle = {
  margin: '0',
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: '600',
};

const courseDetailsStyle = {
  padding: '20px 24px',
  backgroundColor: '#ffffff',
};

const detailBlockStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '16px',
};

const detailIconContainerStyle = {
  width: '24px',
  marginRight: '12px',
  paddingTop: '2px',
};

const detailLabelStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  fontWeight: '500',
  marginBottom: '4px',
};

const detailValueStyle = {
  fontSize: '15px',
  color: textColor,
  fontWeight: '500',
};

const nextStepsStyle = {
  padding: '8px 0 24px 0',
};

const nextStepsTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  color: brandColor,
  margin: '0 0 16px 0',
  padding: '0 40px',
};

const infoListStyle = {
  listStyleType: 'disc',
  margin: '0 0 24px 0',
  padding: '0 40px 0 60px',
};

const infoListItemStyle = {
  fontSize: '15px',
  color: secondaryTextColor,
  lineHeight: '1.5',
  marginBottom: '8px',
};

const buttonContainerStyle = {
  textAlign: 'center' as const,
  margin: '32px 0',
};

const buttonStyle = {
  backgroundColor: brandColor,
  borderRadius: '6px',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
  marginRight: '12px',
};

const secondaryButtonStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '6px',
  border: `1px solid ${brandColor}`,
  color: brandColor,
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  padding: '12px 24px',
  display: 'inline-block',
  transition: 'background-color 0.3s ease',
};

const hrStyle = {
  borderColor: '#E1E4E8',
  margin: '24px 40px',
};

const footerContentStyle = {
  padding: '0 40px 32px 40px',
};

const footerStyle = {
  fontSize: '14px',
  color: secondaryTextColor,
  margin: '8px 0',
};

const contactChannelsStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '8px',
};

const contactChannelStyle = {
  fontSize: '15px',
  color: textColor,
  margin: '6px 0',
  fontWeight: '500',
};

const emailFooterStyle = {
  backgroundColor: backgroundColor,
  padding: '24px 40px',
  textAlign: 'center' as const,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
};

const copyrightStyle = {
  fontSize: '13px',
  color: secondaryTextColor,
  margin: '0 0 12px 0',
};

const footerLinksStyle = {
  margin: '8px 0',
};

const footerLinkStyle = {
  color: brandColor,
  textDecoration: 'none',
  fontSize: '13px',
  fontWeight: '500',
};

const footerDividerStyle = {
  color: secondaryTextColor,
  margin: '0 8px',
};

export default CertificateParticipationEmail; 